export const PluginVersion = "0.3.0";

export const OnBoardingSteps = {
  VERIFY_YOUR_USER_AND_COMPANY_DETAILS: "verify_your_user_and_company_details",
  EXPLORE_THE_TEMPLATE_LIBRARY: "explore_the_template_library",
  ADD_TEAM_MEMBERS_OR_CLIENTS: "add_team_members_or_clients",
  SET_UP_YOUR_SITE_TEMPLATE: "set_up_your_site_template",
  INSTALL_THE_PLUGIN_ON_YOUR_WORDPRESS_WEBSITE:
    "install_the_plugin_on_your_wordPress_website",
};
